import { axios } from '@/utils';

export const getOrdersService = async (actual: boolean, count: number, page: number) =>
  (await axios.get(`/orders?isCashRegister=${actual}&count=${count}&page=${page}`)).data.data;
export const getOrdersByIdService = async (id: string) =>
  (await axios.get(`/orders/${id}`)).data.data;
// export const createOrdersService = async (values: any) => {
//   const { data } = (await axios.post('/orders', values)).data;
//   return data;
// };
export const createOrdersService = async (id?:string,values?: any) => {
  const { data } = (await axios.post('/orders/fullOrder', values));
  return data.data ?? data;
};
export const getPrintCommandersService = async(id: string) =>
  (await axios.get(`/orders/print-commander/${id}`)).data.data;

export const dividerOrdersService = async (id: string, values: any) =>
  (await axios.post(`/orders/divider-order/${id}`, values)).data.data;
export const changeOrderService = async (id?: string,  order?: any)  =>
  (await axios.put(`/orders/changeOrder/${id}`, order)).data.data;
export const addOrderDetailService = async (id?: string, values?: any)  =>
  (await axios.put(`/orders/add/${id}`, values)).data.data;

export const disableOrderById = async (id: string) =>
  (await axios.put(`/orders/disable/${id}`)).data.data;

export const discountOrderService = async (id: string, discount: number) =>
  (await axios.put(`/orders/order-discount/${id}?discount=${discount}`)).data.data;

export const getOrdersCookingService = async () =>
  (await axios.get(`/orders/ordersDetails`)).data.data;

export const changeStatusOrderDetail = async (data: any) =>
  (await axios.put(`/orders/order-detail/status/${data.id}`, data.body)).data.data;

export const reOpenOrder = async (id: string)  =>
  (await axios.put(`/orders/re-open-order/${id}`)).data.data;

export const unifyOrder = async({removeId, unitId}: Record<string,string>) =>
  (await axios.put(`/orders/link-order/${removeId}/${unitId}`)).data.data;

export const logsReOpenOrder = (id: string) => async () =>
  (await axios.get(`/orders/re-open-order/${id}`)).data.data;

export const moveOrder = async (values: any) =>
  (await axios.patch(`/orders/move-order`, values)).data.data;
